import { render, staticRenderFns } from "./GenderSec.vue?vue&type=template&id=148b319c&scoped=true"
import script from "./GenderSec.vue?vue&type=script&lang=js"
export * from "./GenderSec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148b319c",
  null
  
)

export default component.exports